"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProductBoxCarousel = require("./ProductBoxCarousel");
Object.keys(_ProductBoxCarousel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductBoxCarousel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductBoxCarousel[key];
    }
  });
});
var _ProductBoxCarouselSkeleton = require("./ProductBoxCarouselSkeleton");
Object.keys(_ProductBoxCarouselSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductBoxCarouselSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductBoxCarouselSkeleton[key];
    }
  });
});
